const INITIAL_STATE = {
  error: false,
  loading: false,
  data: [],
};

const VariantsList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "VARIANTS_LIST_REQUEST":
      return { loading: true, error: false, data: [] };
    case 'VARIANTS_LIST_ERROR':
      return { loading: false, error: true, data: [] };
    case "VARIANTS_LIST_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default VariantsList;
